import styled from 'styled-components';

export const Center = styled.div`
  margin: 0px auto;
  max-width: 1200px;
`;
